import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-payment-date-helper',
    template: require('./paymentDateHelper.html')
})
export class PaymentDateHelperDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<PaymentDateHelperDialog>) public dialogRef: MatDialogRef<PaymentDateHelperDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value);
    }

}
